/**
 * Type guard that checks if all properties of an object are not null or undefined
 * @param obj The object to check
 * @returns A boolean indicating if all properties are non-null and a type predicate for TypeScript
 */
export function hasAllProperties(obj) {
    if (obj === null || obj === undefined)
        return false;
    // Check each property
    for (const key in obj) {
        if (obj[key] === null || obj[key] === undefined) {
            return false;
        }
    }
    return true;
}
